module.exports = __webpack_public_path__ + "img/iron2.d0e1caeb.png";